import React from "react";
import { motion } from "framer-motion";
import TechnologyStack from "./Technologies1";

const HomeTechnologies = () => {
  const technologies = [
    { name: "React", img: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg" },
    { name: "Node.js", img: "https://miro.medium.com/v2/resize:fit:800/1*COvz0L3FUapYYbsQHHZ90g.png" },
    { name: "Tailwind CSS", img: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg" },
    { name: "Python", img: "https://quantumzeitgeist.com/wp-content/uploads/pythoned.png" },
    { name: "JavaScript", img: "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png" },
    { name: "AWS", img: "https://miro.medium.com/v2/resize:fit:1200/1*tFl-8wQUENETYLjX5mYWuA.png" },
  ];

  return (
  <div className="relative py-20 font-sans overflow-hidden bg-black">

    {/* GOLD TRANSPARENT OVERLAY */}
    <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-black to-[#1a1a1a] opacity-80 z-10"></div>

    {/* CONTENT */}
    <div className="relative z-20 container mx-auto px-6 lg:px-20">

      {/* Heading */}
      <motion.h2
        className="text-4xl md:text-5xl font-extrabold text-center mb-4 
        bg-clip-text text-transparent bg-gradient-to-r from-[#D4AF37] to-[#f5d68a]
        drop-shadow-[0_0_20px_rgba(212,175,55,0.4)]"
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Technology We Leverage
      </motion.h2>

      {/* Paragraph */}
      <motion.p
        className="text-center text-gray-300 text-lg md:text-xl mb-12 max-w-3xl mx-auto"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.3 }}
      >
        Discover the cutting-edge tools and frameworks that power our innovative solutions.
      </motion.p>

      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {technologies.map((tech, idx) => (
          <motion.div
            key={idx}
            className="bg-[#111]/90 backdrop-blur-sm rounded-2xl 
            border border-[#D4AF37] shadow-[0_0_20px_rgba(212,175,55,0.3)]
            p-8 flex flex-col items-center justify-center cursor-pointer
            hover:shadow-[0_0_35px_rgba(212,175,55,0.5)] transition"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: idx * 0.2 }}
            whileHover={{ scale: 1.07 }}
          >
            {/* Image */}
            <motion.img
              src={tech.img}
              alt={tech.name}
              className="w-24 h-24 mb-4 object-contain drop-shadow-[0_0_10px_rgba(212,175,55,0.4)]"
              initial={{ scale: 0.8, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.1 + idx * 0.2 }}
            />

            {/* Name */}
            <motion.h3
              className="text-lg md:text-xl font-bold text-[#f5d68a]"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.2 + idx * 0.2 }}
            >
              {tech.name}
            </motion.h3>
          </motion.div>
        ))}
      </div>

      {/* TechnologyStack Component */}
      <TechnologyStack />
    </div>
  </div>
);

};

export default HomeTechnologies;
